import { setTranslations } from '@ulule/localize'

import * as consent from '@owl-nest/consent'
import * as logger from '@owl-nest/logger'
import { addTrackingListeners, sendTrackingEvent } from '$utils/tracking'
import config from '$utils/config'
import { configure as initApiRequester } from '$utils/apiRequester'
import { initL10nConstants } from './l10n.js'
import { replayLastAction } from './services.js'

const localeLoadedEvent = new CustomEvent('js:locale:loaded', {})

async function fetchLocaleFile() {
  return fetch(window.UFE.localeFile)
    .then((response) => {
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(response.statusText)
      }
    })
    .then((json) => {
      if (json) {
        console.info(`Locale ${window.UFE.locale} has been correctly loaded`)
        setTranslations(json)
        window.dispatchEvent(localeLoadedEvent)
      }
    })
    .catch((error) => {
      console.error(`Locale ${window.UFE.locale} cannot be loaded (error: ${error})`)
      setTranslations({})
      window.dispatchEvent(localeLoadedEvent)
    })
}

;(function () {
  logger.init({
    dsn: window.UFE.sentry_public_dsn,
    environment: window.UFE.environment,
    user: {
      country: window.UFE.country,
      currency: window.CURRENCIES && window.CURRENCIES.CURRENT,
      email: window.UFE.user && window.UFE.user.email,
      id: window.UFE.user && window.UFE.user.id,
      locale: window.UFE.locale,
    },
  })

  if (!window.UFE.iframe) {
    // HACK: listen `load` event to be able to target all nodes even those append by React
    window.addEventListener('load', () => {
      addTrackingListeners()
    })

    document.addEventListener('DOMContentLoaded', async () => {
      // Initialize config utils
      config.set(window.UFE)

      // Configuration of API Requester
      if (window.UFE.api) {
        initApiRequester(window.UFE.api)
      }

      replayLastAction()

      // Add event listeners to specific nodes
      addTrackingListeners()

      // Wait until locale file is loaded
      await fetchLocaleFile()

      // Get current currentLanguage, currentCurrency, currentLocation
      const { currentLanguage, currentCurrency, currentLocation } = await initL10nConstants()
      const currentCountryCode =
        currentLocation && currentLocation.country_code ? currentLocation.country_code : window.UFE.defaultCountry

      // if jQuery is embedded in HTML, we should trigger the event
      if (window.$ !== undefined) {
        $(window).trigger('location:loaded', currentLocation)
      }

      // Dynamic import renderComponents to avoid importing header on widget
      import('./render-components.js').then(({ renderCommonComponents }) => {
        // Render all React common components
        renderCommonComponents(currentLanguage, currentCountryCode, currentCurrency)
      })

      // Send specific event for Ulule Analytics Pro
      if (window.BRANDS_ON_PAGE && window.BRANDS_ON_PAGE.length > 0) {
        sendTrackingEvent('Brand visibility', 'Brands on page', {
          event: 'BRANDevent',
          eventLabel: window.BRANDS_ON_PAGE.join(','),
          nonInteractionEvent: true,
        })
      }

      consent.whenGivenFor(consent.Vendor.ZENDESK, {
        do: () => window.zE && window.zE('webWidget', 'updateSettings', { analytics: true, cookies: true }),
        otherwise: () => window.zE && window.zE('webWidget', 'updateSettings', { analytics: false, cookies: false }),
      })
    })
  } else {
    fetchLocaleFile().then(() => {
      const locationLoadedEvent = new CustomEvent('js:location:loaded')
      window.dispatchEvent(locationLoadedEvent)
    })
  }
})()
